import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import useExportStore from '@export/hooks/useExportStore';

/**
 * Full-screen loading overlay shown while an aligner shell is being generated (mirrors the
 * segmentation processing overlay). Driven by `alignerStatus.state === 'pending'`; success /
 * error are surfaced in the AlignerPanel.
 */
export function AlignerGenerationOverlay() {
  const { alignerStatus } = useExportStore();
  if (alignerStatus.state !== 'pending') return null;

  return (
    <div className="pointer-events-auto fixed inset-0 z-30 flex items-center justify-center bg-black/20 p-6 backdrop-blur-sm">
      <div className="flex w-full max-w-xl flex-col items-center gap-6 rounded-3xl border border-primary/40 bg-content/90 p-10 text-white shadow-2xl shadow-primary/30">
        <p className="text-xs font-semibold uppercase tracking-[0.35em] text-primary/70">Aligner</p>
        <h2 className="text-center text-2xl font-semibold tracking-tight">Generating aligner shell</h2>
        <LoadingSpinner className="text-white" size={72} glowIntensity="md" />
        <p className="text-center text-sm text-white/70">Building the shell from the corrected teeth…</p>
      </div>
    </div>
  );
}
